import React from 'react'
import styled from 'styled-components'
import fetchJsonp from 'fetch-jsonp'
import queryString from 'query-string'
import isEmail from 'validator/lib/isEmail'
import {
  Flex, Box,
  Component,
  Fragment,
  PressButton as Button,
  StaticText,
  Input,
  Loader,
  Text,
} from 'components'

const EmailInput = styled(Input)`
  width: 100%;
`

const FieldSet = styled('fieldset')`
  border: 0;
  padding: 0;
  margin: 0;
`

const USER_ID = '4b4d48a6d670ec6e3fa691b57'
const LIST_ID = '2ba86f2758'
const COMPANY = 'willhoag'
const ACTION = `https://${COMPANY}.us16.list-manage.com/subscribe/post?u=${USER_ID}&amp;id=${LIST_ID}`
const BOT_INPUT_NAME = `b_${USER_ID}_${LIST_ID}`

const getAjaxAction = (emailValue, botFilterValue) => {
  const query = queryString.stringify({
    EMAIL: emailValue,
    [BOT_INPUT_NAME]: botFilterValue,
  })
  const ajaxAction = ACTION.replace('/post?', '/post-json?')
  return `${ajaxAction}&${query}`
}

const MailBoxIcon = ({ status, notStarted }) => {
  if (status === 'success') return <span role="img" aria-label="finished">📫 </span>
  if (notStarted) return <span role="img" aria-label="not started">📭 </span>
  if (status === 'loading') return <span role="img" aria-label="loading">📪 </span>
  if (status === 'error') return <span role="img" aria-label="error">💥 </span>
  return <span role="img" aria-label="started">📬 </span>
}

class EmailSignupForm extends Component {
  constructor ({ emailValue }) {
    super()
    this.state = {
      emailValue: emailValue || '',
      botFilterValue: '',
      message: '',
      status: null,
    }
  }

  async handleSubmit (e) {
    e.preventDefault()
    const { emailValue, botFilterValue } = this.state

    if (!isEmail(emailValue)) {
      this.setState({
        message: 'Invalid Email',
      })
      return
    }

    this.setState({
      status: 'loading',
      message: null,
    })

    const res = await fetchJsonp(getAjaxAction(emailValue, botFilterValue), {
      jsonpCallback: 'c',
    })

    if (!res.ok) {
      this.setState({
        status: 'error',
        error: res.message || 'Error subscribing',
        message: null,
      })
      return
    }

    this.setState({
      status: 'success',
      message: null,
      error: null,
      emailValue: '',
      botFilterValue: '',
    })
  }

  render () {
    const { emailValue, ...rest } = this.props
    return (
      <Box id="subscribe" {...rest}>
        <Text mb={3} fontWeight="bold">
          <MailBoxIcon status={this.state.status} notStarted={!this.state.emailValue} />
          Want to know when I write a new post?
        </Text>
        <form action={ACTION} method="post" target="_blank" noValidate>
          <FieldSet disabled={this.state.status === 'loading'}>
            <Flex>
              <Box flex="1">
                <EmailInput type="email" value={this.state.emailValue}
                  name="EMAIL" disabled={this.state.status === 'success'}
                  placeholder={this.state.status === 'success' ? 'Success!' : 'Your Email Address...'}
                  onChange={e => this.setState({ emailValue: e.target.value, message: null })} />

                {/* Bot Filter */}
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                  <input type="text" name={BOT_INPUT_NAME} tabIndex="-1" value={this.state.botFilterValue}
                    onChange={e => this.setState({ botFilterValue: e.target.value })} />
                </div>
              </Box>
              {this.state.status === 'success'
                ? <StaticText w="170px" textAlign="center" py={3} color="white" bg="positive"><span role="img" aria-label="thumbs up">👍</span>Subscribed</StaticText>
                : <Button w="170px" mt="-5px" type="submit" onClick={e => this.handleSubmit(e)}>
                  { this.state.status === 'loading'
                    ? <Loader height={18} color="white" />
                    : 'Subscribe!' }
                </Button>}
            </Flex>
          </FieldSet>
        </form>
        <Box>
          <Box py={3}>
            {this.state.message && !this.state.error && <Fragment>
              <span role="img" aria-label="attention">☝️</span> {this.state.message}
            </Fragment>}
            {this.state.error && <Fragment>
              <span role="img" aria-label="error">💩</span> {this.state.error}
            </Fragment>}
          </Box>
        </Box>
      </Box>
    )
  }
}

export default EmailSignupForm



// WEBPACK FOOTER //
// /opt/build/repo/src/components/EmailSignUp.js